import React, { useEffect, useState } from 'react';
import { Col, Row, Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Web3 from 'web3';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-phone-number-input/style.css';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';

import Layout from '../../Layout/Layout';
import { getadminuserdata, getuser, updateAdminProfile } from '../../actions/users';
import network from '../../lib/AdminNetwork';
import Market from "../../ABI/market"
import config from '../../lib/config';
import { isEmpty } from '../../actions/commonFunction';
import { IoEye, IoEyeOff } from "react-icons/io5";


const initialFormValue = {
    'name': "",
    'email': "",
    'phonenumber': "",
    'address1': "",
    'address2': "",
    'pincode': "",
    'city': "",
    'country': "",
    'Photofile' : "",
  
  }

const Profile = () => {

    const Wallet_Details = useSelector((state) => state.wallet_connect_context);
    const dispatch = useDispatch()
    const { Id } = useParams();
    const navigate = useNavigate();


    const [formValue, setFormValue] = useState(initialFormValue);
    const [validateError, setValidateError] = useState({});
    const[showpassword, setShowpassword] = useState('password')


    useEffect(() => {
        getConnect()
        // if(Wallet_Details.UserAccountAddr!='')
        // {
    
            getUserData();
    
        // }
    }, [Wallet_Details.UserAccountAddr])

    const getConnect = async () => {
		try {
		  var configdata = {};
		  if (window.ethereum) {
			var web3 = new Web3(window.ethereum);
			
			if (web3 !== undefined) {
			  await window.ethereum.enable().then(async function () {
				const web3 = new Web3(window.web3.currentProvider);
				if (window.web3.currentProvider.networkVersion === "97") {
				  var currentChainId = network.BSC.Chainid;
				  configdata = network.BSC;
				} else if (window.web3.currentProvider.networkVersion == "4") {
				  var currentChainId = network.ETH.Chainid;
				  configdata = network.ETH;
				}
				if (window.web3.currentProvider.networkVersion == currentChainId) {
				  if (window.web3.currentProvider.isMetaMask === true) {
					if (
					  window.web3 &&
					  window.web3.eth &&
					  window.web3.eth.defaultAccount
					) {
					  var currAddr = window.web3.eth.defaultAccount;
					  var CurAddr = String(currAddr).toLowerCase();
					  var result = await web3.eth.getAccounts();
					  var setacc = result[0];
					  
					  var allcontract;
					  (Object.keys(network)).map(val=>{
						allcontract.push(network[val]?.singleContract);
						allcontract.push(network[val]?.multipleContract);
					  })
					  
					  dispatch({
						type: "Account_Connect",
						Account_Detail: {
						  UserAccountAddr: setacc,
						  //   UserAccountBal: accountDetails.coinBalance,
						  WalletConnected: "true",
						  //   Wen_Bln: accountDetails.tokenBalance,
						  Accounts: setacc,
						  providerss: web3._provider,
						  networkConfiguration: configdata,
						//   AllContract: ,
						},
					  });
					 
					}
				  }
				} else {
				//   toast.warning("Please Connect Wallet", toasterOption);
				}
			  });
			}
		  }
		} catch (errr) {
		  console.error("get_connect_error", errr);
		}
	  };

      const onChange = (e) => {
        e.preventDefault();
        const { id, value } = e.target;
        let formData = { ...formValue, ...{ [id]: (id=='email'?String(value?value:'').toLowerCase():value) } }
        setFormValue(formData)
    }

    const onPhoneChange = (value, id) => {
        let formData = { ...formValue, ...{ [id]: value } }
        setFormValue(formData)
    }
    
    const {
        email,
        mobilenumber,
        photo,
        company,
        designation,
        password,
        detail,
        name,adminAddress
    } = formValue

    const Validate = (data) => {
        let errors = {};
        if(isEmpty(data?.company)){
            errors.company = "Company Name Required"
        }
        if(isEmpty(data?.name)){
            errors.name = "Name Required"
        }
        if(isEmpty(data?.email)){
            errors.email = "Email address Required"
        }
        else if (!config.EMAIL.test(data?.email)) {
            errors.email = "Enter Valid Email-Id"
        }
        if(isEmpty(data?.mobilenumber)){
            errors.mobilenumber = "Mobile Number Required"
        }
        else if(!isValidPhoneNumber(String(data?.mobilenumber))){
            errors.mobilenumber = "Enter valid mobile number"
        }
        if(isEmpty(data?.designation)){
            errors.designation = "Designation Required"
        }
        if(isEmpty(data?.password)){
            errors.password = "Password Required"
        }
        else if (!config.PASSWORD.test(data?.password)) {
            errors.password = "Password must contain Alphanumeric"
        }
        return errors;
    }

    const handleFormSubmit = async (e) => {
		var currAddress = adminAddress;
		let reqData = {
			email,
			mobilenumber,
			photo,
			company,
			designation,
			password,
			detail,
			currAddress,
			name,
		}
        let errors = Validate(reqData);
        if(isEmpty(errors)){
            setValidateError({})
            let data = await updateAdminProfile(reqData);
            
            if (data && data.microValue && data.microValue.data && data.microValue.data.status === true) {
                setValidateError({});
                toast.success('Profile updated Successfully',1000);
                getUserData();
            } else {
                setValidateError('Error Occured');
                toast.error('Try-Again',1000);
            }
        }
		else{
            setValidateError(errors);
            toast.error('Fix all validations',1000);
        }
	}

    const getUserData = async () => { 
        var adminAddress=""
        
        let web3;
        if(Wallet_Details.networkConfiguration.BNBPROVIDER){
            web3 = new Web3(Wallet_Details.networkConfiguration.BNBPROVIDER);
        }
      if(web3){
        
    
        const CoursetroContract = new web3.eth.Contract(Market, Wallet_Details.networkConfiguration.TradeContract);
        adminAddress = await CoursetroContract.methods.owner().call();
          adminAddress = adminAddress.toLocaleLowerCase();
        config.adminAddress=adminAddress
        
      }
        var postadata={
          currAddr : adminAddress
        }
        
        var test = await getadminuserdata(postadata);
    
        let formdata = {};
    
        
        if(test && test.adminData && test.adminData.userValue){
            var data = test.adminData;
            formdata['email'] = data.userValue.email;
            formdata['mobilenumber'] = data.userValue.phoneNo;
            formdata['designation'] = data.userValue.designation;
            formdata['detail'] = data.userValue.about;
            formdata['company'] = data.userValue.company;
            formdata['password'] = data.userValue.normalPassword;
            formdata['name'] = data.userValue.name;
            formdata['adminAddress'] = data.userValue.adminAddress;
            setFormValue(formdata);
        }
    
    }
    
    return (
        <Layout>
            <div className="useredit">
                <h1 className="pagehead">Admin Profile</h1>
                <div className="cardbox">
                    <Form>
                        <Row>
                            <Col xs={12} sm={12} md={6} className="mb-3">
                                <Form.Group>
                                    <Form.Label>Company</Form.Label>
                                    <Form.Control
                                        type="text"
                                        onChange={onChange}
                                        id="company"
                                        value={company || ""}
                                        placeholder='Company Name'
                                    />
                                </Form.Group>
                                {
                                validateError.company && <span className={"error_txt"}>{validateError.company}</span>
                            }
                            </Col>
                            
                            <Col xs={12} sm={12} md={6} className="mb-3">
                                <Form.Group>
                                    <Form.Label>Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        onChange={onChange}
                                        id="name"
                                        value={name || ""}
                                        placeholder='Name'
                                    />
                                </Form.Group>
                                {
                                validateError.name && <span className={"error_txt"}>{validateError.name}</span>
                            }
                            </Col>
                            
                            <Col xs={12} sm={12} md={6} className="mb-3">
                                <Form.Group>
                                    <Form.Label>Email address</Form.Label>
                                    <Form.Control
                                        type="text"
                                        onChange={onChange}
                                        value={email || ""}
                                        id="email"
                                        placeholder='Email-Id'
                                    />
                                </Form.Group>
                                {
                                validateError.email && <span className={"error_txt"}>{validateError.email}</span>
                            }
                            </Col>
                            
                            <Col xs={12} sm={12} md={6} className="mb-3">
                                <Form.Group>
                                    <Form.Label>Mobile</Form.Label>
                                    
                                    <PhoneInput
                                        onChange={(e) => onPhoneChange(e,"mobilenumber")}
                                        id='mobilenumber'
                                        value={(mobilenumber?String(mobilenumber):'')}
                                        placeholder='Enter your phone number'
                                        className={`accordion-one__title-input mt-1`}
                                        international // Makes the input accept only international format
                                        withCountryCallingCode // Includes country code in the input
                                    />

                                    {/* <Form.Control
                                        type="text"
                                        onChange={onChange}
                                        value={mobilenumber || ""}
                                        id="mobilenumber"
                                        placeholder='Mobile'
                                    /> */}
                                </Form.Group>
                                {
                                validateError.mobilenumber && <span className={"error_txt"}>{validateError.mobilenumber}</span>
                            }
                            </Col>
                            
                            <Col xs={12} sm={12} md={6} className="mb-3">
                                <Form.Group>
                                    <Form.Label>Designation</Form.Label>
                                    <Form.Control
                                        type="text"
                                        onChange={onChange}
                                        id="designation"
                                        value={designation || ""}
                                        placeholder='Designation'
                                    />
                                </Form.Group>
                                {
                                validateError.designation && <span className={"error_txt"}>{validateError.designation}</span>
                            }
                            </Col>
                            
                            <Col xs={12} sm={12} md={6} className="mb-3">
                                <Form.Group>
                                    <Form.Label>Password</Form.Label>
                                    <div className='position-relative'>
                                    <Form.Control
                                        type={showpassword ? "password" : "text" }
                                        onChange={onChange}
                                        id="password"
                                        value={password || ""}
                                        placeholder='Password'
                                    />
                                     <div className='eyeicon' onClick={()=>setShowpassword(!showpassword)}>{showpassword ? <IoEyeOff/> : <IoEye/>}</div>
                                    </div>
                                </Form.Group>
                                {
                                validateError.password && <span className={"error_txt"}>{validateError.password}</span>
                            }
                            </Col>
                        </Row>
                        <button type="button" className="btn sitebtn py-2 px-3 mt-2" onClick={handleFormSubmit}>Update Profile</button>
                    </Form>
                </div>
            </div>
        </Layout>
    )
}

export default Profile;